import React from "react";
import DashboardMetrics from "components/dashboard/DashboardMetrics";
import ModuleGrid from "components/dashboard/ModuleGrid";

/**
 * Dashboard Principal de Haciendo Camino (Pantalla '/').
 * Reemplaza el layout anterior de tarjetas gigantes por:
 *   - KPIs según rol (Supervisor: global, Director: centro, Operador: oculto)
 *   - Grilla compacta de 3 columnas de módulos principales
 */
const HomeDashboard: React.FC = () => {
  return (
    <div className="w-full space-y-8 pb-10">
      {/* KPIs por Rol */}
      <DashboardMetrics />

      {/* Grilla de Módulos */}
      <ModuleGrid />
    </div>
  );
};

export default HomeDashboard;
